import React, { useState } from "react";
import { Link } from "react-router-dom";

const Header = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  return (
    <>
      {/* 🔶 Marquee */}
      <div
        style={{
          backgroundColor: "#FF9933",
          color: "#fff",
          padding: "8px 0",
          fontSize: "18px",
          fontWeight: "bold",
          textAlign: "center",
        }}
      >
      </div>

      {/* 🔷 Main Header */}
      <header
        style={{
          background:
            "linear-gradient(180deg, #d4a576ff 0%, #e8dcdcff 45%, #87aa84ff 100%)",
          padding: "15px 0",
          borderBottom: "5px solid #000080",
          fontFamily: '"Noto Sans Devanagari", Arial, sans-serif',
        }}
      >
        <div
          style={{
            maxWidth: "1400px",
            margin: "0 auto",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "0 25px",
          }}
        >
          {/* 🇮🇳 National Emblem */}
          <img
            src="/images/sj1.jpg"
            alt="राष्ट्रीय चिन्ह"
            style={{ height: "70px" ,mixBlendMode:"multiply", background:"transparent"}}
          />

          {/* 🏛️ Center Title */}
          <div style={{ textAlign: "center", color: "#000080" }}>
            <h1 style={{ margin: 0, fontSize: "34px", fontWeight: "900" }}>
              ग्रामपंचायत बोरी
            </h1>
            <p style={{ margin: "4px 0", fontSize: "18px", fontWeight: "bold" }}>
              पंचायत समिती कारंजा, जि. वर्धा
            </p>
            <p style={{ margin: 0, fontSize: "14px", fontStyle: "italic" }}>
              ISO 9001:2015 Certified
            </p>
             
          </div>

          {/* 🧑‍🏫 Great Personalities */}
          <div style={{ display: "flex", gap: "12px" }}>
            {[
              "/images/raje.jpg", 
              "/images/Gadgemaharaj.jpg",
              "/images/tujdojimaharaj.jpeg",
            ].map((img, i) => (
              <img
                key={i}
                src={img}
                alt="महापुरुष"
                style={{
                  height: "65px",
                  width: "65px",
                  borderRadius: "50%",
                  border: "3px solid #FF9933",
                  objectFit: "cover",
                }}
              />
            ))}
          </div>
        </div>

        {/* 🔹 Navigation */}
        <nav
          style={{
            marginTop: "12px",
            display: "flex",
            justifyContent: "center",
            gap: "10px",
            flexWrap: "wrap",
          }}
        >
          <Link to="/" className="nav-link">मुख्य पृष्ठ</Link>
          <Link to="/aboutus" className="nav-link">ग्रामपंचायत बद्दल</Link>
          <Link to="/sachiv" className="nav-link">ग्रामपंचायत अधिकारी</Link>
          <Link to="/sarpanch" className="nav-link">सरपंच</Link>
          <Link to="/upsarpanch" className="nav-link">उपसरपंच</Link>
          <Link to="/team" className="nav-link">सदस्य</Link>
          <Link to="/meeting" className="nav-link">ग्रामसभा</Link>

          {/* Dropdown */}
          <div
            style={{ position: "relative" }}
            onMouseEnter={() => setIsDropdownOpen(true)}
            onMouseLeave={() => setIsDropdownOpen(false)}
          >
            <span className="nav-link" style={{ cursor: "pointer" }}>
              दाखले ▼
            </span>
            {isDropdownOpen && (
              <div
                style={{
                  position: "absolute",
                  top: "100%",
                  background: "#fff",
                  padding: "10px",
                  borderRadius: "8px",
                  boxShadow: "0 5px 15px rgba(0,0,0,0.3)",
                }}
              >
                <Link className="dropdown-link" to="/janm-dakhala">जन्म</Link>
                <Link className="dropdown-link" to="/mrut-dakhala">मृत्यू</Link>
                <Link className="dropdown-link" to="/vivah-dakhala">विवाह</Link>
              </div>
            )}
          </div>

          <Link to="/devlopment" className="nav-link">विकास कामे</Link>
          <Link to="/gallery" className="nav-link">छायाचित्र</Link>
          <Link to="/contact" className="nav-link">संपर्क</Link>
        </nav>
      </header>

      {/* CSS */}
      <style>{`
        .nav-link {
          text-decoration: none;
          color: #000080;
          font-weight: 700;
          font-size: 16px;
          padding: 6px 14px;
          border-radius: 20px;
        }
        .nav-link:hover {
          background: #FF9933;
          color: white;
        }
        .dropdown-link {
          display: block;
          color: #138808;
          padding: 6px 10px;
          text-decoration: none;
        }
        .dropdown-link:hover {
          background: #FF9933;
          color: #000080;
        }
      `}</style>
    </>
  );
};

export default Header;
